import svg from './row-svg/surface-parcelle-v2.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function SurfaceParcelleV2Icon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default SurfaceParcelleV2Icon;
